import { hasMyChartAuthorizedEpicFeature } from './Utils.js';


export function getWellness({
    authorizedFeaturesProps,
    canAccessThrive,
    communitySupportBanned,
    disableMyChartMenuItems,
    enableCareCompanion,
    enablePrayerFeature,
    isActiveFeature_Amity,
    isEmployee,
    isMyChartUser,
    isPrimaryUser,
    notPharmacyProxy,
}) {

    return {
        icon: 'icon-profile',
        show: notPharmacyProxy,
        disabled: false,
        navHead: {
            label: 'Wellness',
            url: null,
            icon: 'service'
        },
        navItems: [
            {
                label: 'Thrive',
                show: isPrimaryUser && !isEmployee && canAccessThrive,
                url: '/thrive',
                subMenuItems: null
            },
            {
                label: 'Community Support',
                show: isPrimaryUser && enablePrayerFeature && isActiveFeature_Amity && !communitySupportBanned,
                url: '/communitysupport',
                altUrls: ['/prayerwall'],
                subMenuItems: null
            },
            {
                label: 'Health Tips & Advice',
                show: true,
                url: '/healthtips',
                subMenuItems: null
            },
            {
                label: 'Care Companion',
                show: isMyChartUser && enableCareCompanion, 
                disabled: disableMyChartMenuItems,
                url: '/carecompanion',
                altUrls: ['/carecoachmessage', '/carecoachall'],
                subMenuItems: null
            },
            {
                label: 'Track My Health',
                show: isMyChartUser && hasMyChartAuthorizedEpicFeature("hasAuthorizedFeatureTrackMyHealth", authorizedFeaturesProps),
                disabled: disableMyChartMenuItems,
                url: '/trackmyhealth',
                subMenuItems: null
            }
        ]
    }
}